import { apiRequest } from '../client';
import { getApiToken } from '../authToken';
import { toJsonSafe } from '../json';

export async function getCompany({ companyId, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(`/api/companies/${encodeURIComponent(companyId)}`, {
    token: authToken,
  });
  return result.company;
}

export async function patchCompany({ companyId, company, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(`/api/companies/${encodeURIComponent(companyId)}`, {
    token: authToken,
    method: 'PATCH',
    body: { company: toJsonSafe(company) },
  });
  return result.company;
}

export async function getCompanySetting({ companyId, key, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/settings/${encodeURIComponent(key)}`,
    { token: authToken }
  );
  return result.settings || {};
}

export async function putCompanyRolePermissions({ companyId, role, permissions, rolePermissions, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/role-permissions`,
    {
      token: authToken,
      method: 'PUT',
      body: rolePermissions
        ? { rolePermissions: toJsonSafe(rolePermissions) }
        : { role, permissions: toJsonSafe(permissions) },
    }
  );
  return result;
}

export async function putCompanySetting({ companyId, key, settings, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/settings/${encodeURIComponent(key)}`,
    {
      token: authToken,
      method: 'PUT',
      body: { settings: toJsonSafe(settings) },
    }
  );
  return result.settings || {};
}
